<template>
  <div id="layout">
        <Header />
        <HomeHead />
        <router-view class="main_view"></router-view>
         <Foot   />
  </div>
</template>

<script>
import Header from "./Header";
import Foot from "@/components/Foot";
import HomeHead from "@/components/HomeHead";

export default {
    name:"Layout",
    components:{
        Header,
        Foot,
        HomeHead
    },
    created(){
        
    },
    mounted(){

    }
}
</script>

<style scoped>
    .main_view{
        min-height: calc(100vh - 62px - 206px - 40px);
    }
</style>